// Replacement for https://lodash.com/docs/4.17.15#noop
export const noop = (): undefined => {
    return;
};
